"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseListViewConfigCreatePayloadKindEnum = exports.DatabaseListViewConfigKindEnum = exports.DatabaseBlockCreatePayloadViewEnum = exports.DatabaseBlockCreatePayloadKindEnum = exports.DatabaseBlockViewEnum = exports.DatabaseBlockKindEnum = exports.CountList200ResponseObjectEnum = exports.CountKind = exports.ContentVisibility = exports.ContentType = exports.ContentTextOperationKindEnum = exports.ContentTaskOperationKindEnum = exports.ContentStatus = exports.ContentSearch200ResponseObjectEnum = exports.ContentResponseObjectEnum = exports.ContentResourceOperationKindEnum = exports.ContentQuoteOperationKindEnum = exports.ContentObjectObjectEnum = exports.ContentListItemOperationStyleEnum = exports.ContentListItemOperationKindEnum = exports.ContentHeadingOperationKindEnum = exports.ContentFormOperationKindEnum = exports.ContentFootnoteOperationKindEnum = exports.ContentDividerOperationKindEnum = exports.ContentDatabaseViewOperationKindEnum = exports.ContentDatabaseOperationViewEnum = exports.ContentDatabaseOperationKindEnum = exports.ContentCodeOperationKindEnum = exports.ContentCalloutOperationKindEnum = exports.ContentButtonOperationKindEnum = exports.ConditionIsNotOperatorEnum = exports.ConditionIsOperatorEnum = exports.ColorPalette = exports.CollectionStatus = exports.CollectionList200ResponseObjectEnum = exports.CollectionObjectEnum = exports.CodeBlockCreatePayloadKindEnum = exports.CodeBlockKindEnum = exports.CalloutBlockCreatePayloadKindEnum = exports.CalloutBlockKindEnum = exports.ButtonWebhookActionCreatePayloadTypeEnum = exports.ButtonWebhookActionTypeEnum = exports.ButtonLLMActionCreatePayloadTypeEnum = exports.ButtonLLMActionTypeEnum = exports.ButtonBlockCreatePayloadKindEnum = exports.ButtonBlockKindEnum = exports.BlockListObjectEnum = exports.BlockObjectEnum = exports.AdminWorkspaceList200ResponseObjectEnum = exports.AdminWorkspaceObjectEnum = void 0;
exports.ReferenceSpanKindEnum = exports.RatingPropertyOperationTypeEnum = exports.RatingPropertyCreatePayloadTypeEnum = exports.RatingPropertyTypeEnum = exports.RatingConfigStyleEnum = exports.QuoteBlockCreatePayloadKindEnum = exports.QuoteBlockKindEnum = exports.PrimitivePropertyType = exports.PageFootnoteItemKindEnum = exports.ObjectReferenceListObjectEnum = exports.ObjectReferenceRelationEnum = exports.MentionUserConfigTypeEnum = exports.MentionSpanCreatePayloadKindEnum = exports.MentionSpanKindEnum = exports.MentionPageConfigTypeEnum = exports.MentionObjectObjectEnum = exports.MentionListObjectEnum = exports.ListItemBlockCreatePayloadStyleEnum = exports.ListItemBlockCreatePayloadKindEnum = exports.ListItemBlockStyleEnum = exports.ListItemBlockKindEnum = exports.ImportCreatePayloadFileTypeEnum = exports.HeadingBlockCreatePayloadKindEnum = exports.HeadingBlockKindEnum = exports.FormulaMode = exports.FormulaKind = exports.FormUpdatePayloadStatusEnum = exports.FormList200ResponseObjectEnum = exports.FormCreatePayloadStatusEnum = exports.FormBlockCreatePayloadKindEnum = exports.FormBlockKindEnum = exports.FormAccessLevel = exports.FormStatusEnum = exports.FormObjectEnum = exports.ForigenKeyReferenceSourceKindEnum = exports.ForigenKeyReferenceObjectKindEnum = exports.FootnoteBlockCreatePayloadItemsInnerOneOf1KindEnum = exports.FootnoteBlockCreatePayloadItemsInnerOneOfKindEnum = exports.FootnoteBlockCreatePayloadKindEnum = exports.FootnoteBlockKindEnum = exports.FavoriteList200ResponseObjectEnum = exports.FavoriteObjectEnum = exports.ExternalFootnoteItemKindEnum = exports.EnumPropertyOperationTypeEnum = exports.EnumPropertyCreatePayloadTypeEnum = exports.EnumPropertyTypeEnum = exports.DividerBlockCreatePayloadKindEnum = exports.DividerBlockKindEnum = exports.DatabaseViewBlockCreatePayloadKindEnum = exports.DatabaseViewBlockKindEnum = void 0;
exports.DefaultApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.WorkspaceList200ResponseObjectEnum = exports.WorkspaceObjectEnum = exports.TriggerObjectEnum = exports.TextSpanCreatePayloadKindEnum = exports.TextSpanKindEnum = exports.TextBlockCreatePayloadKindEnum = exports.TextBlockKindEnum = exports.TemplateResourceContentTypeEnum = exports.TemplateResourceCollectionTypeEnum = exports.TaskStatusObjectObjectEnum = exports.TaskStatusListObjectEnum = exports.TaskStatusKind = exports.TaskStatus = exports.TaskObjectObjectEnum = exports.TaskListObjectEnum = exports.TaskBlockCreatePayloadKindEnum = exports.TaskBlockKindEnum = exports.SuggestionStatus = exports.SuggestionPositionBeforeKindEnum = exports.SuggestionPositionAppendKindEnum = exports.SuggestionPositionAfterKindEnum = exports.SuggestionOperationUpdateKindEnum = exports.SuggestionOperationStatus = exports.SuggestionOperationDeleteKindEnum = exports.SuggestionOperationCreateKindEnum = exports.SuggestionObjectObjectEnum = exports.SuggestionListObjectEnum = exports.SubmissionObjectEnum = exports.StackListObjectEnum = exports.StackObjectEnum = exports.SnippetResponseObjectEnum = exports.SnippetObjectObjectEnum = exports.ResourceStreamMode = exports.ResourceStatus = exports.ResourceList200ResponseObjectEnum = exports.ResourceCreateRequestOneOfKindEnum = exports.ResourceBlockCreatePayloadKindEnum = exports.ResourceBlockKindEnum = exports.ResourceObjectEnum = exports.RelationPropertyOperationTypeEnum = exports.RelationPropertyCreatePayloadTypeEnum = exports.RelationPropertyTypeEnum = exports.RelationConfigDirectionEnum = exports.RelationConfigCardinalityEnum = exports.ReferenceSpanCreatePayloadKindEnum = void 0;
exports.FormListStatusEnum = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.AdminWorkspaceObjectEnum = {
    Workspace: 'workspace'
};
exports.AdminWorkspaceList200ResponseObjectEnum = {
    List: 'list'
};
exports.BlockObjectEnum = {
    Block: 'block'
};
exports.BlockListObjectEnum = {
    List: 'list'
};
exports.ButtonBlockKindEnum = {
    Button: 'button'
};
exports.ButtonBlockCreatePayloadKindEnum = {
    Button: 'button'
};
exports.ButtonLLMActionTypeEnum = {
    Llm: 'llm'
};
exports.ButtonLLMActionCreatePayloadTypeEnum = {
    Llm: 'llm'
};
exports.ButtonWebhookActionTypeEnum = {
    Webhook: 'webhook'
};
exports.ButtonWebhookActionCreatePayloadTypeEnum = {
    Webhook: 'webhook'
};
exports.CalloutBlockKindEnum = {
    Callout: 'callout'
};
exports.CalloutBlockCreatePayloadKindEnum = {
    Callout: 'callout'
};
exports.CodeBlockKindEnum = {
    Code: 'code'
};
exports.CodeBlockCreatePayloadKindEnum = {
    Code: 'code'
};
exports.CollectionObjectEnum = {
    Collection: 'collection'
};
exports.CollectionList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CollectionStatus = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ColorPalette = {
    Blue: 'blue',
    Cyan: 'cyan',
    Green: 'green',
    Yellow: 'yellow',
    Orange: 'orange',
    Red: 'red',
    Magenta: 'magenta',
    Indigo: 'indigo',
    Gray: 'gray'
};
exports.ConditionIsOperatorEnum = {
    Is: 'is'
};
exports.ConditionIsNotOperatorEnum = {
    IsNot: 'is_not'
};
exports.ContentButtonOperationKindEnum = {
    Button: 'button'
};
exports.ContentCalloutOperationKindEnum = {
    Callout: 'callout'
};
exports.ContentCodeOperationKindEnum = {
    Code: 'code'
};
exports.ContentDatabaseOperationKindEnum = {
    Database: 'database'
};
exports.ContentDatabaseOperationViewEnum = {
    Table: 'table',
    List: 'list'
};
exports.ContentDatabaseViewOperationKindEnum = {
    DatabaseView: 'database_view'
};
exports.ContentDividerOperationKindEnum = {
    Divider: 'divider'
};
exports.ContentFootnoteOperationKindEnum = {
    Footnote: 'footnote'
};
exports.ContentFormOperationKindEnum = {
    Form: 'form'
};
exports.ContentHeadingOperationKindEnum = {
    Heading: 'heading'
};
exports.ContentListItemOperationKindEnum = {
    ListItem: 'list_item'
};
exports.ContentListItemOperationStyleEnum = {
    Bullet: 'bullet',
    Number: 'number'
};
exports.ContentObjectObjectEnum = {
    Document: 'document'
};
exports.ContentQuoteOperationKindEnum = {
    Quote: 'quote'
};
exports.ContentResourceOperationKindEnum = {
    Resource: 'resource'
};
exports.ContentResponseObjectEnum = {
    List: 'list'
};
exports.ContentSearch200ResponseObjectEnum = {
    List: 'list'
};
/**
 * Status of the content
 * @export
 * @enum {string}
 */
exports.ContentStatus = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
exports.ContentTaskOperationKindEnum = {
    Task: 'task'
};
exports.ContentTextOperationKindEnum = {
    Text: 'text'
};
/**
 * Type of the content
 * @export
 * @enum {string}
 */
exports.ContentType = {
    Report: 'report',
    Playbook: 'playbook',
    CaseStudy: 'case-study',
    Comparison: 'comparison',
    Document: 'document',
    Other: 'other'
};
/**
 * Visibility of the content
 * @export
 * @enum {string}
 */
exports.ContentVisibility = {
    Public: 'public',
    Private: 'private',
    Workspace: 'workspace',
    Unlisted: 'unlisted'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CountKind = {
    CollectionTotal: 'collection.total'
};
exports.CountList200ResponseObjectEnum = {
    List: 'list'
};
exports.DatabaseBlockKindEnum = {
    Database: 'database'
};
exports.DatabaseBlockViewEnum = {
    Table: 'table',
    List: 'list'
};
exports.DatabaseBlockCreatePayloadKindEnum = {
    Database: 'database'
};
exports.DatabaseBlockCreatePayloadViewEnum = {
    Table: 'table',
    List: 'list'
};
exports.DatabaseListViewConfigKindEnum = {
    List: 'list'
};
exports.DatabaseListViewConfigCreatePayloadKindEnum = {
    List: 'list'
};
exports.DatabaseViewBlockKindEnum = {
    DatabaseView: 'database_view'
};
exports.DatabaseViewBlockCreatePayloadKindEnum = {
    DatabaseView: 'database_view'
};
exports.DividerBlockKindEnum = {
    Divider: 'divider'
};
exports.DividerBlockCreatePayloadKindEnum = {
    Divider: 'divider'
};
exports.EnumPropertyTypeEnum = {
    Enum: 'enum'
};
exports.EnumPropertyCreatePayloadTypeEnum = {
    Enum: 'enum'
};
exports.EnumPropertyOperationTypeEnum = {
    Enum: 'enum'
};
exports.ExternalFootnoteItemKindEnum = {
    External: 'external'
};
exports.FavoriteObjectEnum = {
    Favorite: 'favorite'
};
exports.FavoriteList200ResponseObjectEnum = {
    List: 'list'
};
exports.FootnoteBlockKindEnum = {
    Footnote: 'footnote'
};
exports.FootnoteBlockCreatePayloadKindEnum = {
    Footnote: 'footnote'
};
exports.FootnoteBlockCreatePayloadItemsInnerOneOfKindEnum = {
    External: 'external'
};
exports.FootnoteBlockCreatePayloadItemsInnerOneOf1KindEnum = {
    Internal: 'internal'
};
exports.ForigenKeyReferenceObjectKindEnum = {
    Content: 'content',
    Snippet: 'snippet'
};
exports.ForigenKeyReferenceSourceKindEnum = {
    Property: 'property'
};
exports.FormObjectEnum = {
    Form: 'form'
};
exports.FormStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
/**
 * Access level for the form
 * @export
 * @enum {string}
 */
exports.FormAccessLevel = {
    Public: 'public',
    Workspace: 'workspace',
    Private: 'private'
};
exports.FormBlockKindEnum = {
    Form: 'form'
};
exports.FormBlockCreatePayloadKindEnum = {
    Form: 'form'
};
exports.FormCreatePayloadStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
exports.FormList200ResponseObjectEnum = {
    List: 'list'
};
exports.FormUpdatePayloadStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FormulaKind = {
    User: 'current_user',
    Timestamp: 'current_timestamp'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FormulaMode = {
    Stored: 'stored',
    Always: 'always'
};
exports.HeadingBlockKindEnum = {
    Heading: 'heading'
};
exports.HeadingBlockCreatePayloadKindEnum = {
    Heading: 'heading'
};
exports.ImportCreatePayloadFileTypeEnum = {
    Markdown: 'markdown'
};
exports.ListItemBlockKindEnum = {
    ListItem: 'list_item'
};
exports.ListItemBlockStyleEnum = {
    Bullet: 'bullet',
    Number: 'number'
};
exports.ListItemBlockCreatePayloadKindEnum = {
    ListItem: 'list_item'
};
exports.ListItemBlockCreatePayloadStyleEnum = {
    Bullet: 'bullet',
    Number: 'number'
};
exports.MentionListObjectEnum = {
    List: 'list'
};
exports.MentionObjectObjectEnum = {
    Mention: 'mention'
};
exports.MentionPageConfigTypeEnum = {
    Page: 'page'
};
exports.MentionSpanKindEnum = {
    Mention: 'mention'
};
exports.MentionSpanCreatePayloadKindEnum = {
    Mention: 'mention'
};
exports.MentionUserConfigTypeEnum = {
    User: 'user'
};
exports.ObjectReferenceRelationEnum = {
    ContainedIn: 'is_contained_in',
    AncestorOf: 'is_ancestor_of',
    DescendantOf: 'is_descendant_of',
    SiblingOf: 'is_sibling_of'
};
exports.ObjectReferenceListObjectEnum = {
    List: 'list'
};
exports.PageFootnoteItemKindEnum = {
    Page: 'page'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PrimitivePropertyType = {
    String: 'string',
    Text: 'text',
    Email: 'email',
    Integer: 'integer',
    Float: 'float',
    Boolean: 'boolean',
    Date: 'date',
    Datetime: 'datetime',
    Link: 'link',
    User: 'user',
    Snippet: 'snippet'
};
exports.QuoteBlockKindEnum = {
    Quote: 'quote'
};
exports.QuoteBlockCreatePayloadKindEnum = {
    Quote: 'quote'
};
exports.RatingConfigStyleEnum = {
    Numeric: 'numeric',
    Category: 'category'
};
exports.RatingPropertyTypeEnum = {
    Rating: 'rating'
};
exports.RatingPropertyCreatePayloadTypeEnum = {
    Rating: 'rating'
};
exports.RatingPropertyOperationTypeEnum = {
    Rating: 'rating'
};
exports.ReferenceSpanKindEnum = {
    Reference: 'reference'
};
exports.ReferenceSpanCreatePayloadKindEnum = {
    Reference: 'reference'
};
exports.RelationConfigCardinalityEnum = {
    One: 'one',
    Many: 'many'
};
exports.RelationConfigDirectionEnum = {
    Owns: 'owns',
    Inverse: 'inverse'
};
exports.RelationPropertyTypeEnum = {
    Relation: 'relation'
};
exports.RelationPropertyCreatePayloadTypeEnum = {
    Relation: 'relation'
};
exports.RelationPropertyOperationTypeEnum = {
    Relation: 'relation'
};
exports.ResourceObjectEnum = {
    Resource: 'resource'
};
exports.ResourceBlockKindEnum = {
    Resource: 'resource'
};
exports.ResourceBlockCreatePayloadKindEnum = {
    Resource: 'resource'
};
exports.ResourceCreateRequestOneOfKindEnum = {
    Stream: 'stream'
};
exports.ResourceList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResourceStatus = {
    Pending: 'pending',
    Creating: 'creating',
    Ready: 'ready',
    Error: 'error',
    Unhealthy: 'unhealthy'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ResourceStreamMode = {
    Live: 'live',
    Test: 'test'
};
exports.SnippetObjectObjectEnum = {
    Snippet: 'snippet'
};
exports.SnippetResponseObjectEnum = {
    List: 'list'
};
exports.StackObjectEnum = {
    Stack: 'stack'
};
exports.StackListObjectEnum = {
    List: 'list'
};
exports.SubmissionObjectEnum = {
    Submission: 'submission'
};
exports.SuggestionListObjectEnum = {
    List: 'list'
};
exports.SuggestionObjectObjectEnum = {
    Suggestion: 'suggestion'
};
exports.SuggestionOperationCreateKindEnum = {
    Create: 'create'
};
exports.SuggestionOperationDeleteKindEnum = {
    Delete: 'delete'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SuggestionOperationStatus = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected'
};
exports.SuggestionOperationUpdateKindEnum = {
    Update: 'update'
};
exports.SuggestionPositionAfterKindEnum = {
    After: 'after'
};
exports.SuggestionPositionAppendKindEnum = {
    Append: 'append'
};
exports.SuggestionPositionBeforeKindEnum = {
    Before: 'before'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SuggestionStatus = {
    Pending: 'pending',
    Partial: 'partial',
    Accepted: 'accepted',
    Rejected: 'rejected'
};
exports.TaskBlockKindEnum = {
    Task: 'task'
};
exports.TaskBlockCreatePayloadKindEnum = {
    Task: 'task'
};
exports.TaskListObjectEnum = {
    List: 'list'
};
exports.TaskObjectObjectEnum = {
    Task: 'task'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskStatus = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
    Canceled: 'canceled'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskStatusKind = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
    Canceled: 'canceled'
};
exports.TaskStatusListObjectEnum = {
    List: 'list'
};
exports.TaskStatusObjectObjectEnum = {
    TaskStatus: 'task_status'
};
exports.TemplateResourceCollectionTypeEnum = {
    Collection: 'collection'
};
exports.TemplateResourceContentTypeEnum = {
    Document: 'document'
};
exports.TextBlockKindEnum = {
    Text: 'text'
};
exports.TextBlockCreatePayloadKindEnum = {
    Text: 'text'
};
exports.TextSpanKindEnum = {
    Text: 'text'
};
exports.TextSpanCreatePayloadKindEnum = {
    Text: 'text'
};
exports.TriggerObjectEnum = {
    Trigger: 'trigger'
};
exports.WorkspaceObjectEnum = {
    Workspace: 'workspace'
};
exports.WorkspaceList200ResponseObjectEnum = {
    List: 'list'
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary admin workspace create
         * @param {string} [xWorkspaceId]
         * @param {AdminWorkspaceCreatePayload} [adminWorkspaceCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminWorkspaceCreate: async (xWorkspaceId, adminWorkspaceCreatePayload, options = {}) => {
            const localVarPath = `/admin/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminWorkspaceCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin workspace list
         * @param {number | null} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminWorkspaceList: async (limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/admin/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin workspace retrieve
         * @param {string} workspaceId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminWorkspaceRetrieve: async (workspaceId, xWorkspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('adminWorkspaceRetrieve', 'workspaceId', workspaceId);
            const localVarPath = `/admin/workspaces/{workspaceId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary admin workspace create
         * @param {string} [xWorkspaceId]
         * @param {AdminWorkspaceCreatePayload} [adminWorkspaceCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminWorkspaceCreate(xWorkspaceId, adminWorkspaceCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminWorkspaceCreate(xWorkspaceId, adminWorkspaceCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminWorkspaceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin workspace list
         * @param {number | null} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminWorkspaceList(limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminWorkspaceList(limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminWorkspaceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin workspace retrieve
         * @param {string} workspaceId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminWorkspaceRetrieve(workspaceId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminWorkspaceRetrieve(workspaceId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminWorkspaceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         *
         * @summary admin workspace create
         * @param {AdminApiAdminWorkspaceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminWorkspaceCreate(requestParameters = {}, options) {
            return localVarFp.adminWorkspaceCreate(requestParameters.xWorkspaceId, requestParameters.adminWorkspaceCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin workspace list
         * @param {AdminApiAdminWorkspaceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminWorkspaceList(requestParameters = {}, options) {
            return localVarFp.adminWorkspaceList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin workspace retrieve
         * @param {AdminApiAdminWorkspaceRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminWorkspaceRetrieve(requestParameters, options) {
            return localVarFp.adminWorkspaceRetrieve(requestParameters.workspaceId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *
     * @summary admin workspace create
     * @param {AdminApiAdminWorkspaceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminWorkspaceCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminWorkspaceCreate(requestParameters.xWorkspaceId, requestParameters.adminWorkspaceCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin workspace list
     * @param {AdminApiAdminWorkspaceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminWorkspaceList(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminWorkspaceList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin workspace retrieve
     * @param {AdminApiAdminWorkspaceRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminWorkspaceRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminWorkspaceRetrieve(requestParameters.workspaceId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary block create
         * @param {string} [xWorkspaceId]
         * @param {ContentBlockCreatePayload} [contentBlockCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockCreate: async (xWorkspaceId, contentBlockCreatePayload, options = {}) => {
            const localVarPath = `/blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contentBlockCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary block delete
         * @param {string} blockId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockDelete: async (blockId, xWorkspaceId, options = {}) => {
            // verify required parameter 'blockId' is not null or undefined
            (0, common_1.assertParamExists)('blockDelete', 'blockId', blockId);
            const localVarPath = `/blocks/{blockId}`
                .replace(`{${"blockId"}}`, encodeURIComponent(String(blockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary block list
         * @param {string} content
         * @param {string} [version]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockList: async (content, version, xWorkspaceId, options = {}) => {
            // verify required parameter 'content' is not null or undefined
            (0, common_1.assertParamExists)('blockList', 'content', content);
            const localVarPath = `/blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (content !== undefined) {
                localVarQueryParameter['content'] = content;
            }
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary block retrieve
         * @param {string} blockId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockRetrieve: async (blockId, xWorkspaceId, options = {}) => {
            // verify required parameter 'blockId' is not null or undefined
            (0, common_1.assertParamExists)('blockRetrieve', 'blockId', blockId);
            const localVarPath = `/blocks/{blockId}`
                .replace(`{${"blockId"}}`, encodeURIComponent(String(blockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary block update
         * @param {string} blockId
         * @param {string} [xWorkspaceId]
         * @param {BlockCreatePayload} [blockCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUpdate: async (blockId, xWorkspaceId, blockCreatePayload, options = {}) => {
            // verify required parameter 'blockId' is not null or undefined
            (0, common_1.assertParamExists)('blockUpdate', 'blockId', blockId);
            const localVarPath = `/blocks/{blockId}`
                .replace(`{${"blockId"}}`, encodeURIComponent(String(blockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(blockCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary collection create
         * @param {string} [xWorkspaceId]
         * @param {CollectionCreatePayload} [collectionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionCreate: async (xWorkspaceId, collectionCreatePayload, options = {}) => {
            const localVarPath = `/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(collectionCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary collection list
         * @param {number} [limit]
         * @param {string} [key]
         * @param {string} [stack] Filter collections by stack
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionList: async (limit, key, stack, xWorkspaceId, options = {}) => {
            const localVarPath = `/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (stack !== undefined) {
                localVarQueryParameter['stack'] = stack;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary collection retrieve
         * @param {string} collectionId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionRetrieve: async (collectionId, xWorkspaceId, options = {}) => {
            // verify required parameter 'collectionId' is not null or undefined
            (0, common_1.assertParamExists)('collectionRetrieve', 'collectionId', collectionId);
            const localVarPath = `/collections/{collectionId}`
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary collection update
         * @param {string} collectionId
         * @param {string} [xWorkspaceId]
         * @param {CollectionUpdatePayload} [collectionUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionUpdate: async (collectionId, xWorkspaceId, collectionUpdatePayload, options = {}) => {
            // verify required parameter 'collectionId' is not null or undefined
            (0, common_1.assertParamExists)('collectionUpdate', 'collectionId', collectionId);
            const localVarPath = `/collections/{collectionId}`
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(collectionUpdatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary collection upload-csv
         * @param {string} collectionId
         * @param {File} csv
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionUploadCsv: async (collectionId, csv, xWorkspaceId, options = {}) => {
            // verify required parameter 'collectionId' is not null or undefined
            (0, common_1.assertParamExists)('collectionUploadCsv', 'collectionId', collectionId);
            // verify required parameter 'csv' is not null or undefined
            (0, common_1.assertParamExists)('collectionUploadCsv', 'csv', csv);
            const localVarPath = `/collections/{collectionId}/upload-csv`
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (csv !== undefined) {
                localVarFormParams.append('csv', csv);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content archive
         * @param {string} contentId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentArchive: async (contentId, xWorkspaceId, options = {}) => {
            // verify required parameter 'contentId' is not null or undefined
            (0, common_1.assertParamExists)('contentArchive', 'contentId', contentId);
            const localVarPath = `/contents/{contentId}/archive`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content create
         * @param {string} [xWorkspaceId]
         * @param {ContentCreatePayload} [contentCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentCreate: async (xWorkspaceId, contentCreatePayload, options = {}) => {
            const localVarPath = `/contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contentCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content list
         * @param {number} [limit]
         * @param {string} [after]
         * @param {string} [id]
         * @param {ContentStatus} [status]
         * @param {ContentType} [type]
         * @param {string} [slug]
         * @param {string | null} [parent]
         * @param {string} [root]
         * @param {string} [ancestors]
         * @param {string} [collection] Filter content by collection
         * @param {ContentVisibility} [visibility]
         * @param {string} [stack] Filter content by stack
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentList: async (limit, after, id, status, type, slug, parent, root, ancestors, collection, visibility, stack, xWorkspaceId, options = {}) => {
            const localVarPath = `/contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            if (parent !== undefined) {
                localVarQueryParameter['parent'] = parent;
            }
            if (root !== undefined) {
                localVarQueryParameter['root'] = root;
            }
            if (ancestors !== undefined) {
                localVarQueryParameter['ancestors'] = ancestors;
            }
            if (collection !== undefined) {
                localVarQueryParameter['collection'] = collection;
            }
            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }
            if (stack !== undefined) {
                localVarQueryParameter['stack'] = stack;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content retrieve
         * @param {string} contentId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentRetrieve: async (contentId, xWorkspaceId, options = {}) => {
            // verify required parameter 'contentId' is not null or undefined
            (0, common_1.assertParamExists)('contentRetrieve', 'contentId', contentId);
            const localVarPath = `/contents/{contentId}`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content search
         * @param {string} [xWorkspaceId]
         * @param {ContentSearchPayload} [contentSearchPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentSearch: async (xWorkspaceId, contentSearchPayload, options = {}) => {
            const localVarPath = `/contents/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contentSearchPayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content stats
         * @param {string} [xWorkspaceId]
         * @param {ContentStatsRequest} [contentStatsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentStats: async (xWorkspaceId, contentStatsRequest, options = {}) => {
            const localVarPath = `/contents/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contentStatsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content update
         * @param {string} contentId
         * @param {string} [xWorkspaceId]
         * @param {ContentUpdatePayload} [contentUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentUpdate: async (contentId, xWorkspaceId, contentUpdatePayload, options = {}) => {
            // verify required parameter 'contentId' is not null or undefined
            (0, common_1.assertParamExists)('contentUpdate', 'contentId', contentId);
            const localVarPath = `/contents/{contentId}`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contentUpdatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary count list
         * @param {CountKind} kind
         * @param {string} scope
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countList: async (kind, scope, xWorkspaceId, options = {}) => {
            // verify required parameter 'kind' is not null or undefined
            (0, common_1.assertParamExists)('countList', 'kind', kind);
            // verify required parameter 'scope' is not null or undefined
            (0, common_1.assertParamExists)('countList', 'scope', scope);
            const localVarPath = `/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }
            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary favorite create
         * @param {string} [xWorkspaceId]
         * @param {FavoriteCreateRequest} [favoriteCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteCreate: async (xWorkspaceId, favoriteCreateRequest, options = {}) => {
            const localVarPath = `/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(favoriteCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary favorite delete
         * @param {string} favoriteId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteDelete: async (favoriteId, xWorkspaceId, options = {}) => {
            // verify required parameter 'favoriteId' is not null or undefined
            (0, common_1.assertParamExists)('favoriteDelete', 'favoriteId', favoriteId);
            const localVarPath = `/favorites/{favoriteId}`
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary favorite list
         * @param {string} [content] The content id
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteList: async (content, limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (content !== undefined) {
                localVarQueryParameter['content'] = content;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary favorite retrieve
         * @param {string} favoriteId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteRetrieve: async (favoriteId, xWorkspaceId, options = {}) => {
            // verify required parameter 'favoriteId' is not null or undefined
            (0, common_1.assertParamExists)('favoriteRetrieve', 'favoriteId', favoriteId);
            const localVarPath = `/favorites/{favoriteId}`
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary form create
         * @param {string} [xWorkspaceId]
         * @param {FormCreatePayload} [formCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formCreate: async (xWorkspaceId, formCreatePayload, options = {}) => {
            const localVarPath = `/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(formCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary form delete
         * @param {string} formId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formDelete: async (formId, xWorkspaceId, options = {}) => {
            // verify required parameter 'formId' is not null or undefined
            (0, common_1.assertParamExists)('formDelete', 'formId', formId);
            const localVarPath = `/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary form list
         * @param {number} [limit]
         * @param {FormListStatusEnum} [status]
         * @param {string} [collection] Filter forms by collection
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formList: async (limit, status, collection, xWorkspaceId, options = {}) => {
            const localVarPath = `/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (collection !== undefined) {
                localVarQueryParameter['collection'] = collection;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary form retrieve
         * @param {string} formId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formRetrieve: async (formId, xWorkspaceId, options = {}) => {
            // verify required parameter 'formId' is not null or undefined
            (0, common_1.assertParamExists)('formRetrieve', 'formId', formId);
            const localVarPath = `/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary form update
         * @param {string} formId
         * @param {string} [xWorkspaceId]
         * @param {FormUpdatePayload} [formUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formUpdate: async (formId, xWorkspaceId, formUpdatePayload, options = {}) => {
            // verify required parameter 'formId' is not null or undefined
            (0, common_1.assertParamExists)('formUpdate', 'formId', formId);
            const localVarPath = `/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(formUpdatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary import create
         * @param {string} [xWorkspaceId]
         * @param {ImportCreatePayload} [importCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCreate: async (xWorkspaceId, importCreatePayload, options = {}) => {
            const localVarPath = `/stacks/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(importCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary mention list
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mentionList: async (from, to, xWorkspaceId, options = {}) => {
            const localVarPath = `/mentions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary reference resolve
         * @param {string} [xWorkspaceId]
         * @param {ObjectReferenceQuery} [objectReferenceQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referenceResolve: async (xWorkspaceId, objectReferenceQuery, options = {}) => {
            const localVarPath = `/references`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(objectReferenceQuery, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary resource create
         * @param {string} [xWorkspaceId]
         * @param {ResourceCreateRequest} [resourceCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceCreate: async (xWorkspaceId, resourceCreateRequest, options = {}) => {
            const localVarPath = `/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resourceCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary resource list
         * @param {number} [limit]
         * @param {string} [stack] Filter resources by stack
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceList: async (limit, stack, xWorkspaceId, options = {}) => {
            const localVarPath = `/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (stack !== undefined) {
                localVarQueryParameter['stack'] = stack;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary resource retrieve
         * @param {string} resourceId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceRetrieve: async (resourceId, xWorkspaceId, options = {}) => {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('resourceRetrieve', 'resourceId', resourceId);
            const localVarPath = `/resources/{resourceId}`
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary snippet create
         * @param {string} [xWorkspaceId]
         * @param {SnippetCreatePayload} [snippetCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetCreate: async (xWorkspaceId, snippetCreatePayload, options = {}) => {
            const localVarPath = `/snippets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(snippetCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary snippet delete
         * @param {string} snippetId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetDelete: async (snippetId, xWorkspaceId, options = {}) => {
            // verify required parameter 'snippetId' is not null or undefined
            (0, common_1.assertParamExists)('snippetDelete', 'snippetId', snippetId);
            const localVarPath = `/snippets/{snippetId}`
                .replace(`{${"snippetId"}}`, encodeURIComponent(String(snippetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary snippet list
         * @param {number} [limit]
         * @param {string} [after]
         * @param {string} [id]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetList: async (limit, after, id, xWorkspaceId, options = {}) => {
            const localVarPath = `/snippets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary snippet retrieve
         * @param {string} snippetId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetRetrieve: async (snippetId, xWorkspaceId, options = {}) => {
            // verify required parameter 'snippetId' is not null or undefined
            (0, common_1.assertParamExists)('snippetRetrieve', 'snippetId', snippetId);
            const localVarPath = `/snippets/{snippetId}`
                .replace(`{${"snippetId"}}`, encodeURIComponent(String(snippetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary snippet update
         * @param {string} snippetId
         * @param {string} [xWorkspaceId]
         * @param {SnippetUpdatePayload} [snippetUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetUpdate: async (snippetId, xWorkspaceId, snippetUpdatePayload, options = {}) => {
            // verify required parameter 'snippetId' is not null or undefined
            (0, common_1.assertParamExists)('snippetUpdate', 'snippetId', snippetId);
            const localVarPath = `/snippets/{snippetId}`
                .replace(`{${"snippetId"}}`, encodeURIComponent(String(snippetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(snippetUpdatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary stack list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stackList: async (limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/stacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary stack retrieve
         * @param {string} stackId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stackRetrieve: async (stackId, xWorkspaceId, options = {}) => {
            // verify required parameter 'stackId' is not null or undefined
            (0, common_1.assertParamExists)('stackRetrieve', 'stackId', stackId);
            const localVarPath = `/stacks/{stackId}`
                .replace(`{${"stackId"}}`, encodeURIComponent(String(stackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary submission create
         * @param {string} [xWorkspaceId]
         * @param {SubmissionCreatePayload} [submissionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionCreate: async (xWorkspaceId, submissionCreatePayload, options = {}) => {
            const localVarPath = `/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(submissionCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary suggestion create
         * @param {string} [xWorkspaceId]
         * @param {SuggestionCreatePayload} [suggestionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCreate: async (xWorkspaceId, suggestionCreatePayload, options = {}) => {
            const localVarPath = `/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(suggestionCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary suggestion list
         * @param {string} content Content of the suggestion
         * @param {SuggestionStatus} [status]
         * @param {string | null} [creator]
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionList: async (content, status, creator, limit, xWorkspaceId, options = {}) => {
            // verify required parameter 'content' is not null or undefined
            (0, common_1.assertParamExists)('suggestionList', 'content', content);
            const localVarPath = `/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (content !== undefined) {
                localVarQueryParameter['content'] = content;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (creator !== undefined) {
                localVarQueryParameter['creator'] = creator;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task create
         * @param {string} [xWorkspaceId]
         * @param {TaskCreatePayload} [taskCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskCreate: async (xWorkspaceId, taskCreatePayload, options = {}) => {
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task fail
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {TaskFailPayload} [taskFailPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskFail: async (taskId, xWorkspaceId, taskFailPayload, options = {}) => {
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('taskFail', 'taskId', taskId);
            const localVarPath = `/tasks/{taskId}/fail`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskFailPayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskList: async (limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task retrieve
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRetrieve: async (taskId, xWorkspaceId, options = {}) => {
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('taskRetrieve', 'taskId', taskId);
            const localVarPath = `/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task_status create
         * @param {string} [xWorkspaceId]
         * @param {TaskStatusCreateRequest} [taskStatusCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskStatusCreate: async (xWorkspaceId, taskStatusCreateRequest, options = {}) => {
            const localVarPath = `/task_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskStatusCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task_status list
         * @param {string} task The task ID to get the status for
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskStatusList: async (task, limit, xWorkspaceId, options = {}) => {
            // verify required parameter 'task' is not null or undefined
            (0, common_1.assertParamExists)('taskStatusList', 'task', task);
            const localVarPath = `/task_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (task !== undefined) {
                localVarQueryParameter['task'] = task;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task_status retrieve
         * @param {string} statusId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskStatusRetrieve: async (statusId, xWorkspaceId, options = {}) => {
            // verify required parameter 'statusId' is not null or undefined
            (0, common_1.assertParamExists)('taskStatusRetrieve', 'statusId', statusId);
            const localVarPath = `/task_statuses/{statusId}`
                .replace(`{${"statusId"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary trigger create
         * @param {string} [xWorkspaceId]
         * @param {TriggerCreatePayload} [triggerCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerCreate: async (xWorkspaceId, triggerCreatePayload, options = {}) => {
            const localVarPath = `/triggers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(triggerCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace list
         * @param {number | null} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceList: async (limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace retrieve
         * @param {string} workspaceId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceRetrieve: async (workspaceId, xWorkspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('workspaceRetrieve', 'workspaceId', workspaceId);
            const localVarPath = `/workspaces/{workspaceId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary block create
         * @param {string} [xWorkspaceId]
         * @param {ContentBlockCreatePayload} [contentBlockCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockCreate(xWorkspaceId, contentBlockCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockCreate(xWorkspaceId, contentBlockCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.blockCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary block delete
         * @param {string} blockId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockDelete(blockId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockDelete(blockId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.blockDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary block list
         * @param {string} content
         * @param {string} [version]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockList(content, version, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockList(content, version, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.blockList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary block retrieve
         * @param {string} blockId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockRetrieve(blockId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockRetrieve(blockId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.blockRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary block update
         * @param {string} blockId
         * @param {string} [xWorkspaceId]
         * @param {BlockCreatePayload} [blockCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockUpdate(blockId, xWorkspaceId, blockCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockUpdate(blockId, xWorkspaceId, blockCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.blockUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary collection create
         * @param {string} [xWorkspaceId]
         * @param {CollectionCreatePayload} [collectionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectionCreate(xWorkspaceId, collectionCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectionCreate(xWorkspaceId, collectionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.collectionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary collection list
         * @param {number} [limit]
         * @param {string} [key]
         * @param {string} [stack] Filter collections by stack
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectionList(limit, key, stack, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectionList(limit, key, stack, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.collectionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary collection retrieve
         * @param {string} collectionId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectionRetrieve(collectionId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectionRetrieve(collectionId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.collectionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary collection update
         * @param {string} collectionId
         * @param {string} [xWorkspaceId]
         * @param {CollectionUpdatePayload} [collectionUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectionUpdate(collectionId, xWorkspaceId, collectionUpdatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectionUpdate(collectionId, xWorkspaceId, collectionUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.collectionUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary collection upload-csv
         * @param {string} collectionId
         * @param {File} csv
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectionUploadCsv(collectionId, csv, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectionUploadCsv(collectionId, csv, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.collectionUploadCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content archive
         * @param {string} contentId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentArchive(contentId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentArchive(contentId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content create
         * @param {string} [xWorkspaceId]
         * @param {ContentCreatePayload} [contentCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentCreate(xWorkspaceId, contentCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentCreate(xWorkspaceId, contentCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content list
         * @param {number} [limit]
         * @param {string} [after]
         * @param {string} [id]
         * @param {ContentStatus} [status]
         * @param {ContentType} [type]
         * @param {string} [slug]
         * @param {string | null} [parent]
         * @param {string} [root]
         * @param {string} [ancestors]
         * @param {string} [collection] Filter content by collection
         * @param {ContentVisibility} [visibility]
         * @param {string} [stack] Filter content by stack
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentList(limit, after, id, status, type, slug, parent, root, ancestors, collection, visibility, stack, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentList(limit, after, id, status, type, slug, parent, root, ancestors, collection, visibility, stack, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content retrieve
         * @param {string} contentId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentRetrieve(contentId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentRetrieve(contentId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content search
         * @param {string} [xWorkspaceId]
         * @param {ContentSearchPayload} [contentSearchPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentSearch(xWorkspaceId, contentSearchPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentSearch(xWorkspaceId, contentSearchPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content stats
         * @param {string} [xWorkspaceId]
         * @param {ContentStatsRequest} [contentStatsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentStats(xWorkspaceId, contentStatsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentStats(xWorkspaceId, contentStatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content update
         * @param {string} contentId
         * @param {string} [xWorkspaceId]
         * @param {ContentUpdatePayload} [contentUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentUpdate(contentId, xWorkspaceId, contentUpdatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentUpdate(contentId, xWorkspaceId, contentUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary count list
         * @param {CountKind} kind
         * @param {string} scope
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countList(kind, scope, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countList(kind, scope, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.countList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary favorite create
         * @param {string} [xWorkspaceId]
         * @param {FavoriteCreateRequest} [favoriteCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteCreate(xWorkspaceId, favoriteCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteCreate(xWorkspaceId, favoriteCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.favoriteCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary favorite delete
         * @param {string} favoriteId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteDelete(favoriteId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteDelete(favoriteId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.favoriteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary favorite list
         * @param {string} [content] The content id
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteList(content, limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteList(content, limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.favoriteList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary favorite retrieve
         * @param {string} favoriteId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteRetrieve(favoriteId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteRetrieve(favoriteId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.favoriteRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary form create
         * @param {string} [xWorkspaceId]
         * @param {FormCreatePayload} [formCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formCreate(xWorkspaceId, formCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formCreate(xWorkspaceId, formCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.formCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary form delete
         * @param {string} formId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formDelete(formId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formDelete(formId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.formDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary form list
         * @param {number} [limit]
         * @param {FormListStatusEnum} [status]
         * @param {string} [collection] Filter forms by collection
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formList(limit, status, collection, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formList(limit, status, collection, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.formList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary form retrieve
         * @param {string} formId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formRetrieve(formId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formRetrieve(formId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.formRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary form update
         * @param {string} formId
         * @param {string} [xWorkspaceId]
         * @param {FormUpdatePayload} [formUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formUpdate(formId, xWorkspaceId, formUpdatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formUpdate(formId, xWorkspaceId, formUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.formUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary import create
         * @param {string} [xWorkspaceId]
         * @param {ImportCreatePayload} [importCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCreate(xWorkspaceId, importCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCreate(xWorkspaceId, importCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.importCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary mention list
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mentionList(from, to, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mentionList(from, to, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.mentionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary reference resolve
         * @param {string} [xWorkspaceId]
         * @param {ObjectReferenceQuery} [objectReferenceQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referenceResolve(xWorkspaceId, objectReferenceQuery, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referenceResolve(xWorkspaceId, objectReferenceQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.referenceResolve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary resource create
         * @param {string} [xWorkspaceId]
         * @param {ResourceCreateRequest} [resourceCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resourceCreate(xWorkspaceId, resourceCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resourceCreate(xWorkspaceId, resourceCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.resourceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary resource list
         * @param {number} [limit]
         * @param {string} [stack] Filter resources by stack
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resourceList(limit, stack, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resourceList(limit, stack, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.resourceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary resource retrieve
         * @param {string} resourceId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resourceRetrieve(resourceId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resourceRetrieve(resourceId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.resourceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary snippet create
         * @param {string} [xWorkspaceId]
         * @param {SnippetCreatePayload} [snippetCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snippetCreate(xWorkspaceId, snippetCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snippetCreate(xWorkspaceId, snippetCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.snippetCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary snippet delete
         * @param {string} snippetId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snippetDelete(snippetId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snippetDelete(snippetId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.snippetDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary snippet list
         * @param {number} [limit]
         * @param {string} [after]
         * @param {string} [id]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snippetList(limit, after, id, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snippetList(limit, after, id, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.snippetList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary snippet retrieve
         * @param {string} snippetId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snippetRetrieve(snippetId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snippetRetrieve(snippetId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.snippetRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary snippet update
         * @param {string} snippetId
         * @param {string} [xWorkspaceId]
         * @param {SnippetUpdatePayload} [snippetUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snippetUpdate(snippetId, xWorkspaceId, snippetUpdatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snippetUpdate(snippetId, xWorkspaceId, snippetUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.snippetUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary stack list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stackList(limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stackList(limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.stackList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary stack retrieve
         * @param {string} stackId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stackRetrieve(stackId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stackRetrieve(stackId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.stackRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary submission create
         * @param {string} [xWorkspaceId]
         * @param {SubmissionCreatePayload} [submissionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionCreate(xWorkspaceId, submissionCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionCreate(xWorkspaceId, submissionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.submissionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary suggestion create
         * @param {string} [xWorkspaceId]
         * @param {SuggestionCreatePayload} [suggestionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionCreate(xWorkspaceId, suggestionCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionCreate(xWorkspaceId, suggestionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.suggestionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary suggestion list
         * @param {string} content Content of the suggestion
         * @param {SuggestionStatus} [status]
         * @param {string | null} [creator]
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionList(content, status, creator, limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionList(content, status, creator, limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.suggestionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task create
         * @param {string} [xWorkspaceId]
         * @param {TaskCreatePayload} [taskCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskCreate(xWorkspaceId, taskCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskCreate(xWorkspaceId, taskCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task fail
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {TaskFailPayload} [taskFailPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskFail(taskId, xWorkspaceId, taskFailPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskFail(taskId, xWorkspaceId, taskFailPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskFail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskList(limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskList(limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task retrieve
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskRetrieve(taskId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskRetrieve(taskId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task_status create
         * @param {string} [xWorkspaceId]
         * @param {TaskStatusCreateRequest} [taskStatusCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskStatusCreate(xWorkspaceId, taskStatusCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskStatusCreate(xWorkspaceId, taskStatusCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskStatusCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task_status list
         * @param {string} task The task ID to get the status for
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskStatusList(task, limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskStatusList(task, limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskStatusList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task_status retrieve
         * @param {string} statusId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskStatusRetrieve(statusId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskStatusRetrieve(statusId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskStatusRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary trigger create
         * @param {string} [xWorkspaceId]
         * @param {TriggerCreatePayload} [triggerCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerCreate(xWorkspaceId, triggerCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerCreate(xWorkspaceId, triggerCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.triggerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace list
         * @param {number | null} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceList(limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceList(limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace retrieve
         * @param {string} workspaceId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceRetrieve(workspaceId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceRetrieve(workspaceId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary block create
         * @param {DefaultApiBlockCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockCreate(requestParameters = {}, options) {
            return localVarFp.blockCreate(requestParameters.xWorkspaceId, requestParameters.contentBlockCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary block delete
         * @param {DefaultApiBlockDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockDelete(requestParameters, options) {
            return localVarFp.blockDelete(requestParameters.blockId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary block list
         * @param {DefaultApiBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockList(requestParameters, options) {
            return localVarFp.blockList(requestParameters.content, requestParameters.version, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary block retrieve
         * @param {DefaultApiBlockRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockRetrieve(requestParameters, options) {
            return localVarFp.blockRetrieve(requestParameters.blockId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary block update
         * @param {DefaultApiBlockUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUpdate(requestParameters, options) {
            return localVarFp.blockUpdate(requestParameters.blockId, requestParameters.xWorkspaceId, requestParameters.blockCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary collection create
         * @param {DefaultApiCollectionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionCreate(requestParameters = {}, options) {
            return localVarFp.collectionCreate(requestParameters.xWorkspaceId, requestParameters.collectionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary collection list
         * @param {DefaultApiCollectionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionList(requestParameters = {}, options) {
            return localVarFp.collectionList(requestParameters.limit, requestParameters.key, requestParameters.stack, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary collection retrieve
         * @param {DefaultApiCollectionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionRetrieve(requestParameters, options) {
            return localVarFp.collectionRetrieve(requestParameters.collectionId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary collection update
         * @param {DefaultApiCollectionUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionUpdate(requestParameters, options) {
            return localVarFp.collectionUpdate(requestParameters.collectionId, requestParameters.xWorkspaceId, requestParameters.collectionUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary collection upload-csv
         * @param {DefaultApiCollectionUploadCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionUploadCsv(requestParameters, options) {
            return localVarFp.collectionUploadCsv(requestParameters.collectionId, requestParameters.csv, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content archive
         * @param {DefaultApiContentArchiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentArchive(requestParameters, options) {
            return localVarFp.contentArchive(requestParameters.contentId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content create
         * @param {DefaultApiContentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentCreate(requestParameters = {}, options) {
            return localVarFp.contentCreate(requestParameters.xWorkspaceId, requestParameters.contentCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content list
         * @param {DefaultApiContentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentList(requestParameters = {}, options) {
            return localVarFp.contentList(requestParameters.limit, requestParameters.after, requestParameters.id, requestParameters.status, requestParameters.type, requestParameters.slug, requestParameters.parent, requestParameters.root, requestParameters.ancestors, requestParameters.collection, requestParameters.visibility, requestParameters.stack, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content retrieve
         * @param {DefaultApiContentRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentRetrieve(requestParameters, options) {
            return localVarFp.contentRetrieve(requestParameters.contentId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content search
         * @param {DefaultApiContentSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentSearch(requestParameters = {}, options) {
            return localVarFp.contentSearch(requestParameters.xWorkspaceId, requestParameters.contentSearchPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content stats
         * @param {DefaultApiContentStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentStats(requestParameters = {}, options) {
            return localVarFp.contentStats(requestParameters.xWorkspaceId, requestParameters.contentStatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content update
         * @param {DefaultApiContentUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentUpdate(requestParameters, options) {
            return localVarFp.contentUpdate(requestParameters.contentId, requestParameters.xWorkspaceId, requestParameters.contentUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary count list
         * @param {DefaultApiCountListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countList(requestParameters, options) {
            return localVarFp.countList(requestParameters.kind, requestParameters.scope, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary favorite create
         * @param {DefaultApiFavoriteCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteCreate(requestParameters = {}, options) {
            return localVarFp.favoriteCreate(requestParameters.xWorkspaceId, requestParameters.favoriteCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary favorite delete
         * @param {DefaultApiFavoriteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteDelete(requestParameters, options) {
            return localVarFp.favoriteDelete(requestParameters.favoriteId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary favorite list
         * @param {DefaultApiFavoriteListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteList(requestParameters = {}, options) {
            return localVarFp.favoriteList(requestParameters.content, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary favorite retrieve
         * @param {DefaultApiFavoriteRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteRetrieve(requestParameters, options) {
            return localVarFp.favoriteRetrieve(requestParameters.favoriteId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary form create
         * @param {DefaultApiFormCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formCreate(requestParameters = {}, options) {
            return localVarFp.formCreate(requestParameters.xWorkspaceId, requestParameters.formCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary form delete
         * @param {DefaultApiFormDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formDelete(requestParameters, options) {
            return localVarFp.formDelete(requestParameters.formId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary form list
         * @param {DefaultApiFormListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formList(requestParameters = {}, options) {
            return localVarFp.formList(requestParameters.limit, requestParameters.status, requestParameters.collection, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary form retrieve
         * @param {DefaultApiFormRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formRetrieve(requestParameters, options) {
            return localVarFp.formRetrieve(requestParameters.formId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary form update
         * @param {DefaultApiFormUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formUpdate(requestParameters, options) {
            return localVarFp.formUpdate(requestParameters.formId, requestParameters.xWorkspaceId, requestParameters.formUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary import create
         * @param {DefaultApiImportCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCreate(requestParameters = {}, options) {
            return localVarFp.importCreate(requestParameters.xWorkspaceId, requestParameters.importCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary mention list
         * @param {DefaultApiMentionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mentionList(requestParameters = {}, options) {
            return localVarFp.mentionList(requestParameters.from, requestParameters.to, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary reference resolve
         * @param {DefaultApiReferenceResolveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referenceResolve(requestParameters = {}, options) {
            return localVarFp.referenceResolve(requestParameters.xWorkspaceId, requestParameters.objectReferenceQuery, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary resource create
         * @param {DefaultApiResourceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceCreate(requestParameters = {}, options) {
            return localVarFp.resourceCreate(requestParameters.xWorkspaceId, requestParameters.resourceCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary resource list
         * @param {DefaultApiResourceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceList(requestParameters = {}, options) {
            return localVarFp.resourceList(requestParameters.limit, requestParameters.stack, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary resource retrieve
         * @param {DefaultApiResourceRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceRetrieve(requestParameters, options) {
            return localVarFp.resourceRetrieve(requestParameters.resourceId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary snippet create
         * @param {DefaultApiSnippetCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetCreate(requestParameters = {}, options) {
            return localVarFp.snippetCreate(requestParameters.xWorkspaceId, requestParameters.snippetCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary snippet delete
         * @param {DefaultApiSnippetDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetDelete(requestParameters, options) {
            return localVarFp.snippetDelete(requestParameters.snippetId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary snippet list
         * @param {DefaultApiSnippetListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetList(requestParameters = {}, options) {
            return localVarFp.snippetList(requestParameters.limit, requestParameters.after, requestParameters.id, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary snippet retrieve
         * @param {DefaultApiSnippetRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetRetrieve(requestParameters, options) {
            return localVarFp.snippetRetrieve(requestParameters.snippetId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary snippet update
         * @param {DefaultApiSnippetUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snippetUpdate(requestParameters, options) {
            return localVarFp.snippetUpdate(requestParameters.snippetId, requestParameters.xWorkspaceId, requestParameters.snippetUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary stack list
         * @param {DefaultApiStackListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stackList(requestParameters = {}, options) {
            return localVarFp.stackList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary stack retrieve
         * @param {DefaultApiStackRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stackRetrieve(requestParameters, options) {
            return localVarFp.stackRetrieve(requestParameters.stackId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary submission create
         * @param {DefaultApiSubmissionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionCreate(requestParameters = {}, options) {
            return localVarFp.submissionCreate(requestParameters.xWorkspaceId, requestParameters.submissionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary suggestion create
         * @param {DefaultApiSuggestionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionCreate(requestParameters = {}, options) {
            return localVarFp.suggestionCreate(requestParameters.xWorkspaceId, requestParameters.suggestionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary suggestion list
         * @param {DefaultApiSuggestionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionList(requestParameters, options) {
            return localVarFp.suggestionList(requestParameters.content, requestParameters.status, requestParameters.creator, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task create
         * @param {DefaultApiTaskCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskCreate(requestParameters = {}, options) {
            return localVarFp.taskCreate(requestParameters.xWorkspaceId, requestParameters.taskCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task fail
         * @param {DefaultApiTaskFailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskFail(requestParameters, options) {
            return localVarFp.taskFail(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.taskFailPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task list
         * @param {DefaultApiTaskListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskList(requestParameters = {}, options) {
            return localVarFp.taskList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task retrieve
         * @param {DefaultApiTaskRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRetrieve(requestParameters, options) {
            return localVarFp.taskRetrieve(requestParameters.taskId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task_status create
         * @param {DefaultApiTaskStatusCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskStatusCreate(requestParameters = {}, options) {
            return localVarFp.taskStatusCreate(requestParameters.xWorkspaceId, requestParameters.taskStatusCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task_status list
         * @param {DefaultApiTaskStatusListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskStatusList(requestParameters, options) {
            return localVarFp.taskStatusList(requestParameters.task, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task_status retrieve
         * @param {DefaultApiTaskStatusRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskStatusRetrieve(requestParameters, options) {
            return localVarFp.taskStatusRetrieve(requestParameters.statusId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary trigger create
         * @param {DefaultApiTriggerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerCreate(requestParameters = {}, options) {
            return localVarFp.triggerCreate(requestParameters.xWorkspaceId, requestParameters.triggerCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace list
         * @param {DefaultApiWorkspaceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceList(requestParameters = {}, options) {
            return localVarFp.workspaceList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace retrieve
         * @param {DefaultApiWorkspaceRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceRetrieve(requestParameters, options) {
            return localVarFp.workspaceRetrieve(requestParameters.workspaceId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary block create
     * @param {DefaultApiBlockCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    blockCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).blockCreate(requestParameters.xWorkspaceId, requestParameters.contentBlockCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary block delete
     * @param {DefaultApiBlockDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    blockDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).blockDelete(requestParameters.blockId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary block list
     * @param {DefaultApiBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    blockList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).blockList(requestParameters.content, requestParameters.version, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary block retrieve
     * @param {DefaultApiBlockRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    blockRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).blockRetrieve(requestParameters.blockId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary block update
     * @param {DefaultApiBlockUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    blockUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).blockUpdate(requestParameters.blockId, requestParameters.xWorkspaceId, requestParameters.blockCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary collection create
     * @param {DefaultApiCollectionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    collectionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).collectionCreate(requestParameters.xWorkspaceId, requestParameters.collectionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary collection list
     * @param {DefaultApiCollectionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    collectionList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).collectionList(requestParameters.limit, requestParameters.key, requestParameters.stack, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary collection retrieve
     * @param {DefaultApiCollectionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    collectionRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).collectionRetrieve(requestParameters.collectionId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary collection update
     * @param {DefaultApiCollectionUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    collectionUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).collectionUpdate(requestParameters.collectionId, requestParameters.xWorkspaceId, requestParameters.collectionUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary collection upload-csv
     * @param {DefaultApiCollectionUploadCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    collectionUploadCsv(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).collectionUploadCsv(requestParameters.collectionId, requestParameters.csv, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content archive
     * @param {DefaultApiContentArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentArchive(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentArchive(requestParameters.contentId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content create
     * @param {DefaultApiContentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentCreate(requestParameters.xWorkspaceId, requestParameters.contentCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content list
     * @param {DefaultApiContentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentList(requestParameters.limit, requestParameters.after, requestParameters.id, requestParameters.status, requestParameters.type, requestParameters.slug, requestParameters.parent, requestParameters.root, requestParameters.ancestors, requestParameters.collection, requestParameters.visibility, requestParameters.stack, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content retrieve
     * @param {DefaultApiContentRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentRetrieve(requestParameters.contentId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content search
     * @param {DefaultApiContentSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentSearch(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentSearch(requestParameters.xWorkspaceId, requestParameters.contentSearchPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content stats
     * @param {DefaultApiContentStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentStats(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentStats(requestParameters.xWorkspaceId, requestParameters.contentStatsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content update
     * @param {DefaultApiContentUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentUpdate(requestParameters.contentId, requestParameters.xWorkspaceId, requestParameters.contentUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary count list
     * @param {DefaultApiCountListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    countList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).countList(requestParameters.kind, requestParameters.scope, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary favorite create
     * @param {DefaultApiFavoriteCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    favoriteCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).favoriteCreate(requestParameters.xWorkspaceId, requestParameters.favoriteCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary favorite delete
     * @param {DefaultApiFavoriteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    favoriteDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).favoriteDelete(requestParameters.favoriteId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary favorite list
     * @param {DefaultApiFavoriteListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    favoriteList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).favoriteList(requestParameters.content, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary favorite retrieve
     * @param {DefaultApiFavoriteRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    favoriteRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).favoriteRetrieve(requestParameters.favoriteId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary form create
     * @param {DefaultApiFormCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    formCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).formCreate(requestParameters.xWorkspaceId, requestParameters.formCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary form delete
     * @param {DefaultApiFormDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    formDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).formDelete(requestParameters.formId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary form list
     * @param {DefaultApiFormListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    formList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).formList(requestParameters.limit, requestParameters.status, requestParameters.collection, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary form retrieve
     * @param {DefaultApiFormRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    formRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).formRetrieve(requestParameters.formId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary form update
     * @param {DefaultApiFormUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    formUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).formUpdate(requestParameters.formId, requestParameters.xWorkspaceId, requestParameters.formUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary import create
     * @param {DefaultApiImportCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).importCreate(requestParameters.xWorkspaceId, requestParameters.importCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary mention list
     * @param {DefaultApiMentionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    mentionList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).mentionList(requestParameters.from, requestParameters.to, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary reference resolve
     * @param {DefaultApiReferenceResolveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    referenceResolve(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).referenceResolve(requestParameters.xWorkspaceId, requestParameters.objectReferenceQuery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary resource create
     * @param {DefaultApiResourceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    resourceCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).resourceCreate(requestParameters.xWorkspaceId, requestParameters.resourceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary resource list
     * @param {DefaultApiResourceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    resourceList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).resourceList(requestParameters.limit, requestParameters.stack, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary resource retrieve
     * @param {DefaultApiResourceRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    resourceRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).resourceRetrieve(requestParameters.resourceId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary snippet create
     * @param {DefaultApiSnippetCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    snippetCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).snippetCreate(requestParameters.xWorkspaceId, requestParameters.snippetCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary snippet delete
     * @param {DefaultApiSnippetDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    snippetDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).snippetDelete(requestParameters.snippetId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary snippet list
     * @param {DefaultApiSnippetListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    snippetList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).snippetList(requestParameters.limit, requestParameters.after, requestParameters.id, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary snippet retrieve
     * @param {DefaultApiSnippetRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    snippetRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).snippetRetrieve(requestParameters.snippetId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary snippet update
     * @param {DefaultApiSnippetUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    snippetUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).snippetUpdate(requestParameters.snippetId, requestParameters.xWorkspaceId, requestParameters.snippetUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary stack list
     * @param {DefaultApiStackListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    stackList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).stackList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary stack retrieve
     * @param {DefaultApiStackRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    stackRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).stackRetrieve(requestParameters.stackId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary submission create
     * @param {DefaultApiSubmissionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    submissionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).submissionCreate(requestParameters.xWorkspaceId, requestParameters.submissionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary suggestion create
     * @param {DefaultApiSuggestionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    suggestionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).suggestionCreate(requestParameters.xWorkspaceId, requestParameters.suggestionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary suggestion list
     * @param {DefaultApiSuggestionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    suggestionList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).suggestionList(requestParameters.content, requestParameters.status, requestParameters.creator, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task create
     * @param {DefaultApiTaskCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskCreate(requestParameters.xWorkspaceId, requestParameters.taskCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task fail
     * @param {DefaultApiTaskFailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskFail(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskFail(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.taskFailPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task list
     * @param {DefaultApiTaskListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task retrieve
     * @param {DefaultApiTaskRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskRetrieve(requestParameters.taskId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task_status create
     * @param {DefaultApiTaskStatusCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskStatusCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskStatusCreate(requestParameters.xWorkspaceId, requestParameters.taskStatusCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task_status list
     * @param {DefaultApiTaskStatusListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskStatusList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskStatusList(requestParameters.task, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task_status retrieve
     * @param {DefaultApiTaskStatusRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskStatusRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskStatusRetrieve(requestParameters.statusId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary trigger create
     * @param {DefaultApiTriggerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    triggerCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).triggerCreate(requestParameters.xWorkspaceId, requestParameters.triggerCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace list
     * @param {DefaultApiWorkspaceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace retrieve
     * @param {DefaultApiWorkspaceRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceRetrieve(requestParameters.workspaceId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * @export
 */
exports.FormListStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
//# sourceMappingURL=api.js.map